import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 surface-page px-6 text-center">
      <p className="text-3xl font-semibold text-strong">404</p>
      <p className="text-sm text-muted">Diese Seite existiert nicht.</p>
      <Link
        to="/"
        className="mt-2 rounded-lg bg-brand-500 px-3.5 py-2 text-sm font-medium text-white hover:bg-brand-600"
      >
        Zu meinen Aufgaben
      </Link>
    </div>
  );
}
